import * as React from "react";
const SvgBusinessFilled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M4 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19v-4h7v2h6v-2h7v4q0 .825-.587 1.413A1.92 1.92 0 0 1 20 21zm7-6v-2h2v2zm-9-2V8q0-.824.588-1.412A1.93 1.93 0 0 1 4 6h4V4q0-.824.588-1.412A1.93 1.93 0 0 1 10 2h4q.825 0 1.413.588T16 4v2h4q.825 0 1.413.588T22 8v5h-7v-2H9v2zm8-7h4V4h-4z"
    />
  </svg>
);
export default SvgBusinessFilled;
